var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('b-skeleton',{attrs:{"width":"20%"}}),_c('b-skeleton',{attrs:{"width":"40%"}}),_c('b-skeleton',{attrs:{"width":"80%"}}),_c('b-skeleton',{attrs:{"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }